export default __webpack_public_path__ + "static/MonumentGrotesk-Medium-cd1d8d30dff142c9d4b101047b12fe72.woff2";